import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * Inline validation banner for expected rejections — a release date clashing with the first
 * appointment, and the like.
 *
 * Inline rather than the app's alert modal, for two reasons. The design says the blocking condition
 * is "written out, not implied" (screen 5a annotation 4) and puts the equivalent release-date
 * conflict beside the field on screen 8b. And the alert is the catch-all for unexpected failures —
 * an email that already exists, a request that fell over — so routing an ordinary validation
 * outcome through it makes the coordinator dismiss a dialog before they can see what to change.
 *
 * Colours from the Hi-Fi handoff: warning-ink on warning-light. The live build's orange-on-orange
 * fails 4.5:1, so those values are not reused.
 */

interface Props {
  title: string;
  detail?: string;
}

const ValidationBanner: React.FC<Props> = ({ title, detail }) => (
  <Box
    role="alert"
    sx={{
      backgroundColor: "#FFE7C2",
      color: "#7A3200",
      borderRadius: 1,
      p: 2,
    }}
  >
    <Typography variant="body2" sx={{ fontWeight: 600 }}>
      {title}
    </Typography>
    {detail ? <Typography variant="body2">{detail}</Typography> : null}
  </Box>
);

export default ValidationBanner;
